import { AfterViewChecked, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { findAncestor, maxZIndex } from '../common/utils';
import { ResizableEvent } from '../resizable';

@Component({
  selector: 'app-modal',
  templateUrl: 'modal.component.html',
  styleUrls: ['modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalComponent implements OnInit, AfterViewChecked {

  @Input() modalTitle: string;
  @Input() width: any;
  @Input() height: any;
  @Input() zIndex: number;
  @Input() minWidth: number = 260;
  @Input() minHeight: number = 200;
  @Input() scrollTop: boolean = true;
  @Input() maximizable: boolean;
  @Input() minimizable: boolean;
  @Input() backdrop: boolean = true;
  @Input() multipleDialogOffset: number = 0;
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  @Output() minimizeModal: EventEmitter<boolean> = new EventEmitter();
  @Input() customCloseEvent: boolean;
  @ViewChild('modalRoot') modalRoot: ElementRef;
  @ViewChild('modalBody') modalBody: ElementRef;
  @ViewChild('modalHeader') modalHeader: ElementRef;
  @ViewChild('modalFooter') modalFooter: ElementRef;


  @HostBinding('class.app-modal') cssClass = true;
  timeoutObject: any;
  visible: boolean;
  contentzIndex: number;
  executePostDisplayActions: boolean;
  maximized: boolean;
  minimized: boolean;
  preMaximizeRootWidth: number;
  preMaximizeRootHeight: number;
  preMaximizeBodyHeight: number;
  preMaximizePageX: number;
  preMaximizePageY: number;
  dragEventTarget: MouseEvent | TouchEvent;

  constructor(private element: ElementRef, private _renderer: Renderer2) { }
  ngOnDestroy() {
    document.querySelector('#modal-container').removeChild(this.modalRoot.nativeElement);

  }
  ngOnInit() {
    if (!this.zIndex) {
      this.zIndex = this.getMaxModalIndex();
      this.zIndex = (this.zIndex || 1000) + 1;
    }
    this.contentzIndex = this.zIndex + 1;

    this.show();
  }


  ngAfterViewChecked() {
    if (this.executePostDisplayActions) {
      this.center();
      this.executePostDisplayActions = false;
    }
  }

  // 
  @HostListener('document:keydown.escape', ['$event'])
  onKeyDown(event): void {
    this.minimizeModal.emit(true);
    event.preventDefault();
    event.stopPropagation();

  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.executePostDisplayActions = true;
    this.center();
  }

  show(): void {
    this.executePostDisplayActions = true;
    this.visible = true;
    this.timeoutObject = setTimeout(() => {
      this.modalRoot.nativeElement.focus();
      document.querySelector('#modal-container').appendChild(this.modalRoot.nativeElement);
      if (this.minHeight) {
        this.modalRoot.nativeElement.style.height = this.minHeight + 'px';
      }
      this.center();
      this.calcBodyHeight();

      if (this.scrollTop) {
        this.modalBody.nativeElement.scrollTop = 0;
      }
      clearTimeout(this.timeoutObject);
    }, 1);
  }

  hide(): void {
    if (this.customCloseEvent) {
      this.closeEvent.emit(true);
    } else {
      this.visible = false;
      this.closeModal.emit(true);
      this.focusLastModal();
    }
  }

  center() {
    let elementWidth = this.modalRoot.nativeElement.offsetWidth;
    let elementHeight = this.modalRoot.nativeElement.offsetHeight;
    const headerHeight = this.modalHeader.nativeElement.offsetHeight;
    const footerHeight = this.modalFooter.nativeElement.offsetHeight;

    if (elementWidth === 0 && elementHeight === 0) {
      this.modalRoot.nativeElement.style.visibility = 'hidden';
      this.modalRoot.nativeElement.style.display = 'block';
      elementWidth = this.modalRoot.nativeElement.offsetWidth;
      elementHeight = this.modalRoot.nativeElement.offsetHeight;
      this.modalRoot.nativeElement.style.display = 'none';
      this.modalRoot.nativeElement.style.visibility = 'visible';
    } else {
      // this.modalBody.nativeElement.style.height = elementHeight - (headerHeight + footerHeight) + 'px';
    }

    const x = Math.max((window.innerWidth - elementWidth) / 2, 0);
    const y = Math.max((window.innerHeight - elementHeight) / 2, 0);

    //this.modalRoot.nativeElement.style.left = x + 'px';
    //this.modalRoot.nativeElement.style.top = y + 'px';
    this.modalRoot.nativeElement.style.transform = 'translate(' + Math.ceil(x) + 'px, ' + Math.ceil(y) + 'px)';

    if (this.multipleDialogOffset > 0) {
      let parsedX: number = x + this.multipleDialogOffset * 33;
      let parsedY: number = y + this.multipleDialogOffset * 33;
      this.modalRoot.nativeElement.style.transform = 'translate(' + Math.ceil(parsedX) + 'px, ' + Math.ceil(parsedY) + 'px)';
    }


  }

  initDrag(event: MouseEvent | TouchEvent) {
    if (!this.maximized) {
      this.dragEventTarget = event;
    }
  }

  onResize(event: ResizableEvent) {
    if (event.direction === 'vertical') {
      this.calcBodyHeight();
    }
  }

  calcBodyHeight() {
    const headerHeight = this.modalHeader.nativeElement.offsetHeight;
    const footerHeight = this.modalFooter.nativeElement.offsetHeight;
    let contentHeight = 0;
    if (footerHeight < 10) {
      this.modalFooter.nativeElement.style = 'display: none';
      contentHeight = this.modalRoot.nativeElement.offsetHeight - (headerHeight + 2);
    } else {
      contentHeight = this.modalRoot.nativeElement.offsetHeight - (headerHeight + footerHeight);
    }

    this.modalBody.nativeElement.style.height = contentHeight + 'px';
    this.modalBody.nativeElement.style.maxHeight = 'none';

  }

  getMaxModalIndex() {
    return maxZIndex('.ui-modal');
  }

  focusLastModal() {
    const modal = findAncestor(this.element.nativeElement.parentElement, 'app-modal');
    if (modal && modal.children[1]) {
      modal.children[1].focus();
    }
  }

  onCloseIcon(event: Event) {
    event.stopPropagation();

  }

  toggleMaximize(event) {
    if (this.maximized) {
      this.revertMaximize();
    } else {
      this.maximize();
    }
    event.preventDefault();
  }



  maximize() {
    this.preMaximizePageX = parseFloat(this.modalRoot.nativeElement.style.transform.split('translate')[1].split(',')[0].replace('px', '').replace('(', '').replace(')', '').trim());
    this.preMaximizePageY = parseFloat(this.modalRoot.nativeElement.style.transform.split('translate')[1].split(',')[1].replace('px', '').replace('(', '').replace(')', '').trim());
    this.preMaximizeRootWidth = this.modalRoot.nativeElement.offsetWidth;
    this.preMaximizeRootHeight = this.modalRoot.nativeElement.offsetHeight;
    this.preMaximizeBodyHeight = this.modalBody.nativeElement.offsetHeight;

    this.modalRoot.nativeElement.style.transform = 'translate(7px,55px)';
    //this.modalRoot.nativeElement.style.left = '7px';
    this.modalRoot.nativeElement.style.width = 'calc(100vw - 14px)';
    this.modalRoot.nativeElement.style.height = 'calc(100vh - 62px)';
    const diffHeight = this.modalHeader.nativeElement.offsetHeight;
    let parsedHeight: number = diffHeight - 62;
    this.calcBodyHeight();

    this.maximized = true;
  }

  toggleMinimize(event) {
    this.minimizeModal.emit(true);
    /*
    if (this.minimized) {
      this.revertMinimize();
    } else {
      this.minimize();
    }
    */
    event.preventDefault();
  }

  revertMinimize() {
    this.modalRoot.nativeElement.style.height = this.preMaximizeRootHeight + 'px';


    this.minimized = false;
  }
  minimize() {
    this.preMaximizeRootHeight = this.modalRoot.nativeElement.offsetHeight;
    this.modalRoot.nativeElement.style.height = 31 + 'px';
    this.minimized = true;
  }

  revertMaximize() {
    //this.modalRoot.nativeElement.style.top = this.preMaximizePageX + 'px';
    //this.modalRoot.nativeElement.style.left = this.preMaximizePageY + 'px';
    this.modalRoot.nativeElement.style.transform = 'translate(' + this.preMaximizePageX + 'px, ' + this.preMaximizePageY + 'px)';
    this.modalRoot.nativeElement.style.height = this.preMaximizeRootHeight + 'px';
    this.modalRoot.nativeElement.style.width = this.preMaximizeRootWidth + 'px';
    this.modalBody.nativeElement.style.height = this.preMaximizeBodyHeight + 'px';

    this.maximized = false;
  }

  moveOnTop() {
    if (!this.backdrop) {
      const zIndex = this.getMaxModalIndex();
      if (this.contentzIndex <= zIndex) {
        this.contentzIndex = zIndex + 1;
      }
    }
  }

  get dialogStyles() {
    return {
      display: this.visible ? 'block' : 'none',
      'z-index': this.contentzIndex,
      'width.px': this.width,
      'min-height.px': this.height,
      'min-width.px': this.minWidth,
    };
  }

  get overlayStyles() {
    return {
      display: (this.visible && this.backdrop) ? 'block' : 'none',
      'z-index': this.zIndex,
    };
  }

}
